import { IRawVariant, IVariant } from '~/shared/types/variantTypes'

export const getVariantFromRawVariant = (
  rawVariant: IRawVariant,
): IVariant => ({
  cohort: rawVariant.cohort_id,
  parentCohort: rawVariant.parent_cohort_id,
  facebookPixelIds: rawVariant.facebook_pixel_ids,
  tiktokPixelId: rawVariant.tiktok_pixel_id,
  hasUpsellOffer: rawVariant.has_upsell_offer,
  growthBookExperiments: rawVariant.optimize_map,
  onboardingProgressBreakpoints: rawVariant.onboarding_progress_breakpoints,
  googleTagManagerId: rawVariant.google_analytics_id,
  applovinPixelId: rawVariant.applovin_pixel_id,
  hasCancelOffer: rawVariant.has_cancel_offer,
  steps: rawVariant.steps.map((step) => ({
    id: step.page_id,
    isPayment: step.is_payment,
    isUpsell: step.is_upsell,
    isQuestion: step.is_question,
    isSkippable: step.is_skippable,
    isSubscriptions: step.is_subscriptions,
    hasHeader: step.has_header,
    hasProgressBar: step.has_progressbar,
  })),
})
